import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_31af10wylw: FaireBrandEntity = {
  token: "b_31af10wylw",
  type: "brand",
  name: "JAYONE",
  avatarUrl:
    "https://cdn.faire.com/fastly/4bec6ba6f6cec939af2f2b9306896bbe80c4b28299aa494d1cff0f75f497fd91.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1ce19f4cbaeb2906f41a2c12ad3b5db3ad78a195db2266a68b0a3389637fc6a3.png",
  logoUrl:
    "https://cdn.faire.com/fastly/4bec6ba6f6cec939af2f2b9306896bbe80c4b28299aa494d1cff0f75f497fd91.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1ce19f4cbaeb2906f41a2c12ad3b5db3ad78a195db2266a68b0a3389637fc6a3.png",
  location: "Paramount, CA, USA",
  minimumOrderDollars: 100,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "Jayone sparked a game-changing shift as the first company to introduce roasted seaweed as a healthy snacking option. Since then, we’ve developed over 800 different foods, including sauces, canned kimchi, and many vegan food items. We employ cost-reducing measures such as contract farming and global sourcing for high-quality ingredients to be carefully processed at our cutting-edge manufacturing sites.\n\nAs pioneers in the food market, every product is subject to meticulous inspection throughout the value chain to ensure that it meets standards and exceeds expectations. At Jayone Foods, we believe in bringing the delicious and nutritious flavors of Korea and Asia to the world. This commitment extends beyond the quality of our food; it encompasses the ethical and responsible practices we uphold throughout our business operations. ",
  meta: {
    source: "api",
    importedAt: "2026-05-05T05:28:44.597Z",
    importedBy: "entity-db-cli",
  },
};
